import axios from 'axios';


const authToken = () => {
    let token = JSON.parse(localStorage.getItem('Aprofile'));
    return token?.token; // Using optional chaining to handle cases where token is undefined or null
  }
  
 export const Api = axios.create({
    baseURL: process.env.REACT_APP_BE_URL,
    timeout: 5000,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  });
  
  Api.interceptors.request.use((config) => {
    const token = authToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  });

